import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell, StyledButtonBlack
} from "../../../styles/MyStyles";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {GetEnumMenuItems} from "../../../logic/EnumHelper";
import {GetLookupMenuItems} from "../../../logic/LookupHelper";
import {GetTransferBankSides, GetTransferCryptoSides} from "../../../logic/TrasferHelper";

const TransferEditPage = () => {
    const { clientId, transferId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [transfer, setTransfer] = useState({
        date: '',
        type: 0,
        fromId: '',
        toId: '',
        amountFrom: '',
        amountTo: '',
        fee: '',
        feeAssetId: '',
        chainalysisTransferReference: ''
    });

    const [wallets, setWallets] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);

    useEffect(() => {
        const fetchTransfer = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (transferId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_TRANSFERS_URL}/single/${transferId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        setTransfer(data.data);
                    } else {
                        console.log('Fetch transfer failed.');
                    }
                } else {
                    setTransfer({
                        date: '',
                        type: 0,
                        fromId: '',
                        toId: '',
                        amountFrom: '',
                        amountTo: '',
                        fee: '',
                        feeAssetId: '',
                        chainalysisTransferReference: ''
                    });
                    console.log(transfer);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        const fetchWallets = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(
                    `${process.env.REACT_APP_WALLETS_URL}/${clientId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + tokenCookie.value,
                        },
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    console.log(data.data);
                    setWallets(data.data);
                } else {
                    console.log('Fetch wallets failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        const fetchBankAccounts = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(
                    `${process.env.REACT_APP_BANK_ACCOUNTS_URL}/${clientId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + tokenCookie.value,
                        },
                    }
                );
                if (response.ok) {
                    const data = await response.json();
                    console.log(data.data);
                    setBankAccounts(data.data);
                } else {
                    console.log('Fetch bank accounts failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchWallets();
        fetchBankAccounts();
        fetchTransfer();
    }, [transferId]);

    const validateForm = () => {
        let newErrors = {};

        if (transfer.date === '') {
            newErrors.date = 'Date is required.';
        }
        if (transfer.fromId === '') {
            newErrors.fromId = 'From is required.';
        }
        if (transfer.toId === '') {
            newErrors.toId = 'To is required.';
        }
        if (transfer.amountFrom === '') {
            newErrors.amountFrom = 'Amount From is required.';
        } else if (isNaN(transfer.amountFrom)) {
            newErrors.amountFrom = 'Amount From must be number.';
        }
        if (transfer.amountTo === '') {
            newErrors.amountTo = 'Amount To is required.';
        } else if (isNaN(transfer.amountTo)) {
            newErrors.amountTo = 'Amount To must be number.';
        }
        if (transfer.fee === '') {
            newErrors.fee = 'Fee is required.';
        } else if (isNaN(transfer.fee)) {
            newErrors.fee = 'Fee must be number.';
        }
        if (transfer.feeAssetId === '') {
            newErrors.feeAssetId = 'Fee Asset is required.';
        }

        if (transfer.type === 0 && transfer.chainalysisTransferReference === '') {
            newErrors.chainalysisTransferReference = 'Chainalysis Transfer Reference is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {

        if (event.target.name === 'type') {
            transfer.fromId = '';
            transfer.toId = '';
        }

        setTransfer({
            ...transfer,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TRANSFERS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(transfer),
                }
            );
            if (response.ok) {
                console.log('Transfer updated successfully.');
                handleGoBack();
            } else {
                console.log('Update transfer failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleDelete = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TRANSFERS_URL}/${transferId}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                console.log('Transfer deleted successfully.');
                handleGoBack();
            } else {
                console.log('Delete transfer failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {transferId ? 'Edit Transfer' : 'Create Transfer'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
                {(transferId && <StyledButtonBlack variant="contained" onClick={handleDelete}>
                    Delete
                </StyledButtonBlack>)}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={transfer.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {GetEnumMenuItems('transferType')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="date"
                                label="Date"
                                value={dayjs(transfer.date)}
                                onChange={(date) =>  {
                                    var event = {
                                        'target': {
                                            'name': 'date',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                            }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.date}
                                helperText={errors.date}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>From Account</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="fromId"
                                label="From Account"
                                select
                                value={transfer.fromId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.fromId}
                                helperText={errors.fromId}
                            >
                                {transfer.type === 0
                                    ? GetTransferCryptoSides(wallets, true, transfer.toId)
                                    : GetTransferBankSides(bankAccounts, true, transfer.toId)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Amount From</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="amountFrom"
                                label="Amount From"
                                value={transfer.amountFrom}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.amountFrom}
                                helperText={errors.amountFrom}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>To Account</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="toId"
                                label="To Account"
                                select
                                value={transfer.toId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.toId}
                                helperText={errors.toId}
                            >
                                {transfer.type === 0
                                    ? GetTransferCryptoSides(wallets, true, transfer.fromId)
                                    : GetTransferBankSides(bankAccounts, true, transfer.fromId)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Amount To</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="amountTo"
                                label="Amount To"
                                value={transfer.amountTo}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.amountTo}
                                helperText={errors.amountTo}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Transaction Fee</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="fee"
                                label="Transaction Fee"
                                value={transfer.fee}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.fee}
                                helperText={errors.fee}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Fee Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="feeAssetId"
                                label="Fee Asset"
                                select
                                value={transfer.feeAssetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.feeAssetId}
                                helperText={errors.feeAssetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    {transfer.type === 0 && (
                        <TableRow>
                            <StyledTableCell style={{ width: '10%' }}>Chainalysis Transfer Reference</StyledTableCell>
                            <TableCell style={{ width: '90%' }}>
                                <TextField
                                    name="chainalysisTransferReference"
                                    label="Chainalysis Transfer Reference"
                                    value={transfer.chainalysisTransferReference}
                                    onChange={handleFieldChange}
                                    fullWidth
                                    required
                                    error={!!errors.chainalysisTransferReference}
                                    helperText={errors.chainalysisTransferReference}
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Container>
    );
};

export default TransferEditPage;
